export const applyGoalModifiers = ({ modifiers }) => modifiers.reduce((res, m) => {
  res = m(res);
  return res;
}, {});
